import React from "react";
import PropTypes from "prop-types";
import iconsList from "@sunwing/icons/dist/vacances-westjet-quebec/icons.json";
import { Icon } from "../../components/Icons";

const IconConnector = ({ data }) => <Icon name={data.iconName} />;
IconConnector.displayName = "Icon";

IconConnector.propTypes = {
	data: PropTypes.shape({
		iconName: PropTypes.oneOf(iconsList).isRequired,
	}).isRequired,
};

export { IconConnector, iconsList };
